import { HighlightStyle, syntaxHighlighting } from '@codemirror/language';
import { tags as lezerHighlightTags } from '@lezer/highlight';
import { EditorView } from '@codemirror/view';

const colors = {
    primary: 'var(--bs-app-primary)',
    light: 'var(--bs-app-foreground)',
    color: 'var(--bs-app-foreground)',
    background: 'var(--bs-app-background-20)',
    autocompleteBg: 'var(--bs-app-background-10)',
    autocompleteColor: 'var(--bs-app-foreground-40)',
    autocompleteHover: 'var(--bs-background-15)',
    autocompleteMatchColor: 'var(--bs-app-foreground)',
    autocompleteMatchDecoration: 'var(--bs-app-foreground)',
    autocompleteSelectedBg: 'var(--bs-app-background-25)'
};

const fontStack = {
    mono: 'Consolas, "Lucida Console", "Courier New", Courier,monospace',
    sansSerif: 'LabGrotesque, sans-serif'
};

const primaryTokenStyle = {
    color: colors.primary,
    fontWeight: 'bold',
    fontSize: '.9rem',
    fontFamily: fontStack.sansSerif,
    textRendering: 'optimizelegibility'
};

export const filterBarTheme = [
    EditorView.theme({
        '&': {
            color: colors.color,
            backgroundColor: colors.background
        },
        '&.cm-editor.cm-focused': {
            outline: 'none'
        },
        '.cm-scroller': {
            fontFamily: fontStack.mono,
            fontSize: '1rem',
            lineHeight: '1.6rem'
        },
        '.cm-content': {
            caretColor: colors.light
        },
        '.cm-cursor, .cm-dropCursor': {
            borderLeftColor: colors.light
        },
        '.cm-searchMatch.cm-searchMatch-selected, .cm-selectionMatch, .cm-activeLine, .cm-activeLineGutter': {
            backgroundColor: colors.background
        },
        '.cm-tooltip': {
            border: 'none',
            backgroundColor: colors.autocompleteBg,
            fontFamily: fontStack.sansSerif,
            '& .cm-tooltip-arrow': {
                '&:before': {
                    borderTopColor: 'transparent',
                    borderBottomColor: 'transparent'
                },
                '&:after': {
                    borderTopColor: colors.autocompleteBg,
                    borderBottomColor: colors.autocompleteBg
                }
            },
            '&.cm-tooltip-autocomplete': {
                borderRadius: 'var(--bs-app-border-radius)',
                border: `1px solid ${colors.background}`,
                padding: '0',
                color: colors.autocompleteColor,
                '& .cm-completionMatchedText': {
                    textDecorationColor: 'transparent'
                },
                '& > ul > li': {
                    borderBottom: '1px solid var(--bs-app-background-25)',
                    fontFamily: fontStack.sansSerif,
                    padding: '0.25rem 0.5rem',
                    '&[aria-selected]': {
                        fontWeight: 400,
                        color: colors.color,
                        backgroundColor: colors.autocompleteSelectedBg
                    },
                    '&:not([aria-selected]):hover': {
                        color: colors.color,
                        backgroundColor: colors.autocompleteHover,
                        '& .cm-completionMatchedText': {
                            color: colors.autocompleteMatchColor,
                            textDecorationColor:
                                colors.autocompleteMatchDecoration
                        }
                    }
                }
            }
        }
    }),
    syntaxHighlighting(
        HighlightStyle.define([
            {
                tag: lezerHighlightTags.keyword,
                ...primaryTokenStyle
            },
            {
                tag: lezerHighlightTags.operator,
                ...primaryTokenStyle,
                letterSpacing: '2px',
                padding: '0 3px'
            }
        ])
    )
];
